"use client";

import React from "react";
import { Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HolDirDenUnbegrenztenTurbo() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222301" id="join-the-joy" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden relative" ref={ref}>
      {}
      <style>{`
        @keyframes customScalePulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.02); }
        }
        .animate-custom-scale-pulse {
          animation: customScalePulse 3s infinite ease-in-out;
        }
      `}</style>

      <div className={`max-w-5xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="relative rounded-3xl p-[2px] bg-[conic-gradient(from_180deg_at_50%_50%,var(--color-primary)_0%,var(--color-accent)_50%,var(--color-primary)_100%)] shadow-xl shadow-primary/5">
          
          {}
          <div className="bg-background/90 backdrop-blur-2xl p-8 md:p-16 lg:p-24 flex flex-col items-center text-center gap-10 relative overflow-hidden rounded-3xl">

            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-full max-h-lg bg-primary/5 blur-[120px] rounded-lg pointer-events-none" />

            <div className="relative z-10 space-y-6 max-w-3xl">
              <h2 className="text-4xl md:text-5xl lg:text-7xl font-normal font-default text-foreground leading-tight tracking-widest">
                Join the Joy
              </h2>

              <p className="text-lg md:text-xl text-muted-foreground font-default max-w-2xl mx-auto tracking-wide">
                We can't wait to celebrate our love story with you. Please let us know if you can join us for this special day.
              </p>
            </div>

            <div className="relative z-10 mt-4 flex flex-col items-center gap-6">
              <Button asChild size="lg" className="animate-custom-scale-pulse h-16 px-10 md:px-14 text-lg md:text-xl font-medium tracking-widest rounded-md bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg border border-primary/20 transition-colors">
                <Link to="/RSVPPage">
                  RSVP Now <Zap className="ml-3 size-6 fill-current" />
                </Link>
              </Button>
              
              <Link to="#" className="text-sm font-default uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors">
                Add to Calendar
              </Link>
            </div>
            
          </div>
        </div>
      </div>
    </section>;
}